import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/src/layouts/default.vue").then(m => m.default || m))
}